// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"214f802f","239":"3e52cb10","732":"5ea8b453","777":"625e0e11","977":"2eb20047"}[chunkId] + ".chunk.js";
};